'use strict';

import { Vector3 } from 'three';
import { getWorldData } from '../controls/orbitControls';
import { radToDeg } from 'three/src/math/MathUtils';
import gsap from 'gsap';
import { settingsData } from '../../settings';
import { ViewMode } from '../../common';

export class Disappear {
    static #objectsToDisappear = [];
    static #cameraVec = new Vector3();
    static #objectVec = new Vector3();

    #mesh;
    #duration;
    #disappearDegrees;

    constructor (mesh,disappearDegrees = 45, duration = 0.3) {
        this.#mesh = mesh;
        this.#disappearDegrees = disappearDegrees;
        this.#duration = duration;

        Disappear.#objectsToDisappear.push(this);
    }

    hide() {
        if (this.#mesh.material.opacity < 1) return;

        gsap.to(this.#mesh.material,{
            duration: this.#duration,
            opacity: 0,
            onStart: () => {
                this.#mesh.material.transparent = true;
            }
        });
    }

    show() {
        if (this.#mesh.material.opacity > 0) return;

        gsap.to(this.#mesh.material,{
            duration: this.#duration,
            opacity: 1,
            onComplete: () => {
                this.#mesh.material.transparent = false;
            }
        });
    }

    getMesh() {
        return this.#mesh;
    }

    getDisappearDegrees() {
        return this.#disappearDegrees;
    }

    static update() {

        if (!Disappear.#objectsToDisappear.length || settingsData.activeViewMode !== ViewMode.Orbit) return;

        const { cameraVector } = getWorldData();

        for (let i = 0; i < Disappear.#objectsToDisappear.length; i++) {
            const object = Disappear.#objectsToDisappear[i];
            const objectMesh = object.getMesh();
            const disappearDegrees = object.getDisappearDegrees();

            Disappear.#objectVec.copy(objectMesh.position);
            Disappear.#cameraVec.copy(cameraVector);

            const angle = Disappear.#cameraVec.angleTo(Disappear.#objectVec);
            const degrees = radToDeg(angle);

            if (degrees < disappearDegrees) {
                object.hide();
            } else {
                object.show();
            }
        }
    }
}